/**
 * Footer starter chips shown on every fresh chat, on every page.
 */

export const STARTER_CHIPS = [
	'Recent Critical Alarms',
	'Total Access Points Offline',
	'Create a Site',
	'Add Access Points to a Site',
];
